import * as React from 'react';

import { Address } from '../../models/address';
import AddressSearchBox from '../AddressSearch/AddressSearchBox';
import AddressMap from '../AddressSearch/AddressMap';

interface ICreditRequestReturnAddressesProps {
  pickupAddress: Address;
  destinationAddress: Address;
  pickupError?: string;
  destinationError?: string;
  disabled: boolean;
  onPickupAddressChange(address: Address): void;
  onDestinationAddressChange(address: Address): void;
  setMapCoordinates?(fieldName: string, lat: number, lng: number): void;
}

export const CreditRequestReturnAddresses: React.SFC<ICreditRequestReturnAddressesProps> = props => {
  const renderAddress = (
    label: string,
    fieldName: string,
    address: Address,
    error: string | undefined,
    onChange: (address: Address) => void,
  ) => (
    <AddressSearchBox
      address={address.formattedAddress}
      handleAddressSelected={onChange}
      handleChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(new Address({
        ...address,
        formattedAddress: event.currentTarget.value,
      }))}
      label={label}
      fieldName={fieldName}
      error={error || address.errors.formattedAddress}
      toggleMap
      disabled={props.disabled}
    >
      <AddressMap
        forFieldName={fieldName}
        moveMarker={!props.disabled}
        lat={address.latLng.lat}
        lng={address.latLng.lng}
        handleClick={(lat: number, lng: number) => {
          if (props.setMapCoordinates) props.setMapCoordinates(fieldName, lat, lng);
          onChange(new Address({ ...address, latLng: { lat, lng } }));
        }}
      />
    </AddressSearchBox>
  );

  return (
    <React.Fragment>
      {renderAddress(
        'Pickup Address',
        'refundFromAddress',
        props.pickupAddress,
        props.pickupError,
        props.onPickupAddressChange,
      )}
      {renderAddress(
        'Return Address',
        'refundToAddress',
        props.destinationAddress,
        props.destinationError,
        props.onDestinationAddressChange,
      )}
    </React.Fragment>
  );
};
